import { combineReducers } from '@ngrx/store';

import { betBuilderReducer } from '../bet-builder/reducer';
import { comboBetReducer } from '../combo-bet/reducer';
import { editBetReducer } from '../edit-bet/reducer';
import { singleBetReducer } from '../single-bet/reducer';
import { systemBetReducer } from '../system-bet/reducer';
import { teaserBetReducer } from '../teaser-bet/reducer';
import { baseTypeReducer } from './base/reducer';
import { IBetslipTypeState } from './state';

export const typesReducer = combineReducers<IBetslipTypeState>({
    base: baseTypeReducer,
    singleBet: singleBetReducer,
    comboBet: comboBetReducer,
    systemBet: systemBetReducer,
    teaserBet: teaserBetReducer,
    editBet: editBetReducer,
    betBuilder: betBuilderReducer,
});
